module.exports = __webpack_public_path__ + "img/snake-steal.fe29b5c3.gif";